import { render, staticRenderFns } from "./wxMessage.vue?vue&type=template&id=45dfe9fc&scoped=true"
import script from "./wxMessage?vue&type=script&lang=js&external"
export * from "./wxMessage?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dfe9fc",
  null
  
)

export default component.exports